import React from 'react';

import { Typography } from '@mui/material';

import { useH_서비스별_요금_가져오기 } from '../hooks/useH_서비스별_요금_가져오기';

export const AI_통합서비스_요금_테이블 = React.memo(function AI_통합서비스_요금_테이블() {
  const { AI_통합서비스_요금 } = useH_서비스별_요금_가져오기();

  return (
    <div
      style={{
        borderRadius: '8px',
        overflow: 'hidden',
        border: '1px solid #E0E0E0',
      }}
    >
      <table
        style={{
          width: '100%',
          borderCollapse: 'separate',
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr style={{ height: 36, background: '#FAFAFA' }}>
            <th style={{ borderRight: '1px solid #E0E0E0' }}>
              <Typography variant="Button_Looko">월별 상품 수</Typography>
            </th>
            <th>
              <Typography variant="Button_Looko">상품당 요금</Typography>
            </th>
          </tr>
        </thead>

        <tbody>
          {AI_통합서비스_요금?.pricingPerItemUsages.map((v, index, total) => (
            <tr style={{ height: 36 }} key={index}>
              <td
                style={{
                  background: '#FAFAFA',
                  borderRight: '1px solid #E0E0E0',
                  textAlign: 'center',
                  ...(index !== total.length - 1 ? { borderBottom: '1px solid #E0E0E0' } : undefined),
                  ...(index === 0 ? { borderTop: '1px solid #E0E0E0' } : undefined),
                }}
              >
                {index === total.length - 1 ? (
                  <Typography variant="Button_Looko">{v.minItemRange}번째 상품~</Typography>
                ) : (
                  <Typography variant="Button_Looko">
                    {v.minItemRange}~{v.maxItemRange}번째 상품
                  </Typography>
                )}
              </td>
              <td
                style={{
                  background: 'white',
                  textAlign: 'center',
                  ...(index !== total.length - 1 ? { borderBottom: '1px solid #E0E0E0' } : undefined),
                  ...(index === 0 ? { borderTop: '1px solid #E0E0E0' } : undefined),
                }}
              >
                <Typography variant="Button_Looko">{v.fee.aimsPriceWon}</Typography>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});
